import { render, staticRenderFns } from "./classicCases.vue?vue&type=template&id=4dbd74e7&scoped=true&"
import script from "./classicCases.vue?vue&type=script&lang=js&"
export * from "./classicCases.vue?vue&type=script&lang=js&"
import style0 from "./classicCases.vue?vue&type=style&index=0&id=4dbd74e7&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd74e7",
  null
  
)

export default component.exports